import { useSaveTaskModalDetailSectionQuery } from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  title: string;
  description: string;
  dueDate: DateTime | null;
  assignedTo: string | null;
  area: string | null;
  category: string | null;
  attachments: {
    id: string;
    fileName: string;
    fileSize: string;
    url: string;
  }[];
}

export function useQuery(id: string) {
  const tuple = useSaveTaskModalDetailSectionQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.task?.id ?? '',
        title: tuple.data?.task?.name ?? '',
        description: tuple.data?.task?.description ?? '',
        dueDate: tuple.data?.task?.dueDate ?? null,
        assignedTo: tuple.data?.task?.assignee?.fullName ?? null,
        area: tuple.data?.task?.area?.displayName ?? null,
        category: tuple.data?.task?.category?.displayName ?? null,
        attachments: tuple.data?.task?.attachments.map((node) => ({
          id: node.id,
          fileName: node.fileName,
          fileSize: node.formattedFileSize,
          url: node.url
        })) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
